document.addEventListener("DOMContentLoaded", () => {

    const headerSection = document.querySelector("#shopify-section-sections--23307948294379__header");
    const header = document.querySelector("#header");
    const announcement = document.querySelector("#shopify-section-sections--23307948294379__new-announcement-bar");

    if (!headerSection || !header) return;

    function updateHeights(){

        const headerHeight = header.offsetHeight;
        const announcementHeight = announcement ? announcement.offsetHeight : 0;

        document.documentElement.style.setProperty(
            "--header-height",
            headerHeight + "px"
        );

        document.documentElement.style.setProperty(
            "--announcement-height",
            announcementHeight + "px"
        );

        document.body.style.paddingTop =
            (headerHeight + announcementHeight) + "px";
    }

    updateHeights();

    window.addEventListener("resize", updateHeights);
    window.addEventListener("load", updateHeights);

    let sticky = false;

    window.addEventListener("scroll", () => {

        if(window.scrollY > 10){

            if(sticky) return;
            sticky = true;

            announcement?.classList.add("hide");
            headerSection.classList.add("sticky");
            header.classList.add("is-sticky");
            
        }else{

            if(!sticky) return;
            sticky = false;

            announcement?.classList.remove("hide");
            headerSection.classList.remove("sticky");
            header.classList.remove("is-sticky");

        }

    },{passive:true});

});